if (window.location.pathname.includes('/it')) {
  document.querySelector("#splide01-slide03 .material-icon.material-symbols-outlined").innerHTML = "star";
}


  

//check of het een product page is
if (window.location.pathname.includes('/products/')) {

  // Functie om voorraad tekst te klonen en toe te voegen aan de prijs container
  function cloneStockText() {
    const prijsContainer = document.querySelector(".product-page-price");
    const voorraadText = document.querySelector(".product__inventory");

    // Controleer of zowel prijsContainer als voorraadText aanwezig zijn
    if (prijsContainer && voorraadText) {
      // Verwijder de oude gekloonde voorraadtekst, als deze er is
      const oldClonedStockText = prijsContainer.querySelector('.cloned-stock-text');
      if (oldClonedStockText) {
        oldClonedStockText.remove();
      }

      // Maak een nieuw element voor de gekloonde voorraadtekst (bijv. een div)
      const clonedStockText = document.createElement('div');
      // Zet de tekst van het originele voorraad element in het gekloonde element
      clonedStockText.textContent = voorraadText.textContent;

      // Voeg een class toe aan het gekloonde element om het makkelijk te identificeren
      clonedStockText.classList.add('cloned-stock-text');

      // Controleer de tekstinhoud en voeg de juiste class toe

      console.log(clonedStockText.textContent);

      
      
  const inventoryElement = document.querySelector('.product__inventory');
  const cleanedText = inventoryElement.textContent.trim().replace(/\s+/g, ' ');
  
  console.log("Schoongemaakte tekst:", cleanedText);
  
  if (
    cleanedText.includes("Auf Lager") || 
    cleanedText.includes("Disponibile") || 
    cleanedText.includes("Op Voorraad") || 
    cleanedText.includes("In Stock") || 
    cleanedText.includes("En Stock") || 
    cleanedText.includes("En Existencias")
  ) {
    inventoryElement.classList.add('opvoorraad');
  } else if (cleanedText.includes("Niedriger Lagerbestand")) {
    inventoryElement.classList.add('lagevoorraad');
  } else {
    inventoryElement.classList.add('uitverkocht');
  }



      // Voeg de gekloonde voorraadtekst toe aan de prijscontainer
      prijsContainer.appendChild(clonedStockText);
    }
  }

  // Kloneren bij het laden van de pagina
  cloneStockText();

  // Luister naar klik events op de pagina en voeg een vertraging toe van 300 ms
  document.addEventListener('click', function(event) {
    // Voeg een vertraging toe van 300ms voordat we de voorraadtekst klonen
    setTimeout(function() {
      cloneStockText();
    }, 300); // Vertraging van 300ms
  });


  
  function updateSoldCount() {
    let aantalVerkocht = document.querySelector(".zegsu-sold-count-val");
    if (aantalVerkocht) {
      const randomNummer = Math.floor(Math.random() * (15000 - 18000 + 1)) + 18000;
      aantalVerkocht.textContent = `${randomNummer}+`;
    } 

      let soldText = document.querySelector(".zegsu-sold-main > span:last-child")
      let extention = window.location.hostname;
      let ratingLink = document.querySelector(".rating-stars-and-text span a");
      
      if (extention.endsWith(".nl")) {
          soldText.innerHTML = "Verkocht"; // Nederlands
          ratingLink.href = "https://www.trustedshops.nl/verkopersbeoordeling/info_XBADDEB913FB5B83C21A248057C903A9E.html";
      } else if (extention.endsWith(".de")) {
          soldText.innerHTML = "Verkauft"; // Duits
      } else if (extention.endsWith(".fr")) {  
          soldText.innerHTML = "Vendu"; // Frans
          ratingLink.href = "https://www.trustedshops.fr/evaluation/info_XB928F39D143BA58813CE940B7DE250F8.html";
      } else if (extention.endsWith(".it")) {
          soldText.innerHTML = "Venduto"; // Italiaans
          ratingLink.href = "https://www.trustedshops.it/valutazione-del-negozio/info_XBFB4E0B26347C00A2D6F246897B4219C.html";
      } else if (extention.endsWith(".es")) {
          soldText.innerHTML = "Vendido"; // Spaans
          ratingLink.href = "https://www.trustedshops.es/evaluacion/cleanfoods-es";
      }
        
  }
    
  setTimeout(function() {
    updateSoldCount();
  }, 1000);
}






const path = window.location.pathname;
const stars = document.querySelector(".rating-stars-and-text");

if (stars) {
  if (path.includes('/nl/products/')) stars.classList.add("nlstars");
  if (path.includes('/it/products/')) stars.classList.add("itstars");
}




  


